import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { apiFetch } from "api/Api";
import { Link } from "react-router-dom";
import BASE_URL from "api/Api";
import "assets/theme/admin_list.css";
import { FaImages, FaPlus, FaEdit, FaTrash } from "react-icons/fa";

const GalleryList = () => {
  const [gallery, setGallery] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchGallery = async () => {
    try {
      const res = await apiFetch("leader_admin/get_gallery");
      setGallery(res.data || []);
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGallery();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("आपण ही गॅलरी हटवू इच्छिता?")) return;

    try {
      await apiFetch(`leader_admin/delete_gallery/${id}`, { method: "DELETE" });
      fetchGallery();
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="admin-page-container">
        {/* Header */}
        <div className="admin-header-card d-flex align-items-center justify-content-between flex-wrap gap-3">
          <div className="d-flex align-items-center">
            <div className="admin-header-icon">
              <FaImages />
            </div>
            <div>
              <h4 className="admin-header-title">गॅलरी व्यवस्थापन यादी</h4>
              <p className="admin-header-subtitle mb-0">
                गॅलरी छायाचित्रे, श्रेणी व मुख्य इव्हेंट प्राधान्य व्यवस्थापित करा
              </p>
            </div>
          </div>
          <Link to="/add_gallery" className="btn-admin-add">
            <FaPlus /> नवीन फोटो जोडा
          </Link>
        </div>

        {/* Table Card */}
        <div className="admin-table-card">
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-warning" role="status" />
              <p className="mt-2 text-muted fw-semibold">गॅलरी लोड होत आहे...</p>
            </div>
          ) : gallery.length === 0 ? (
            <div className="text-center py-5 text-muted">
              कोणतीही गॅलरी प्रतिमा उपलब्ध नाही.
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-admin-custom">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>प्रतिमा (Image)</th>
                    <th>श्रेणी (Category)</th>
                    <th>शीर्षक (Title)</th>
                    <th>मुख्य इव्हेंट</th>
                    <th className="text-end">कृती (Actions)</th>
                  </tr>
                </thead>

                <tbody>
                  {gallery.map((item, index) => (
                    <tr key={item.id}>
                      <td className="fw-bold text-secondary">{index + 1}</td>

                      {/* Image Preview */}
                      <td>
                        <img
                          src={`${BASE_URL}/${item.image}`}
                          alt="gallery"
                          className="admin-table-thumb"
                          style={{ width: "64px", height: "48px" }}
                        />
                      </td>

                      {/* Category */}
                      <td>
                        <span className="badge bg-light text-dark border fw-semibold">
                          {item.category_name || "सामान्य"}
                        </span>
                      </td>

                      {/* Title */}
                      <td className="fw-bold text-dark">{item.title}</td>

                      {/* Main Badge */}
                      <td>
                        {item.is_main === true || item.is_main === "true" ? (
                          <span className="badge-status badge-status-warning">
                            ⭐ मुख्य इव्हेंट
                          </span>
                        ) : (
                          <span className="badge-status badge-status-info">
                            सामान्य
                          </span>
                        )}
                      </td>

                      {/* Actions */}
                      <td className="text-end">
                        <div className="admin-action-group justify-content-end">
                          <Link
                            to={`/edit_gallery/${item.id}`}
                            className="btn-action-icon btn-action-edit"
                            title="संपादन करा"
                          >
                            <FaEdit />
                          </Link>

                          <button
                            onClick={() => handleDelete(item.id)}
                            className="btn-action-icon btn-action-delete"
                            title="हटवा"
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default GalleryList;